import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      role: 'Cloud Engineer at TCS',
      image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Rajesh',
      text: 'The cloud training program at CloudXAI was exceptional. The instructors had deep industry knowledge, and the hands-on labs prepared me perfectly for my current role.',
      rating: 5,
      type: 'Training',
    },
    {
      name: 'Priya Sharma',
      role: 'Full Stack Developer at Infosys',
      image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Priya',
      text: 'Thanks to CloudXAI\'s placement assistance, I landed my dream job. Their career guidance and interview preparation were invaluable.',
      rating: 5,
      type: 'Placement',
    },
    {
      name: 'Vikram Singh',
      role: 'HR Manager at Tech Solutions Ltd',
      image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Vikram',
      text: 'We hired 10 candidates from CloudXAI for our development team. Every single hire has exceeded our expectations. Highly recommended!',
      rating: 5,
      type: 'Corporate',
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#111827]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 font-['Space_Grotesk']">
            What Our <span className="bg-gradient-to-r from-[#00E5FF] to-[#1DE9B6] bg-clip-text text-transparent">Clients Say</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#00E5FF] to-transparent mx-auto mb-4"></div>
          <p className="text-xl text-[#9CA3AF]">Success stories from our community</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="bg-[rgba(17,24,39,0.6)] backdrop-blur-xl border-2 border-[#00E5FF]/20 hover:border-[#00E5FF]/50 shadow-xl hover:shadow-2xl hover:shadow-[#00E5FF]/20 transition-all duration-300 hover:-translate-y-2 group">
              <CardContent className="p-8">
                <div className="mb-6">
                  <Quote className="w-10 h-10 text-[#00E5FF] opacity-50" />
                </div>

                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#00E5FF] text-[#00E5FF]" />
                  ))}
                </div>

                <p className="text-[#9CA3AF] leading-relaxed mb-6 italic">"{testimonial.text}"</p>

                <div className="flex items-center space-x-4">
                  <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full border-2 border-[#00E5FF]/30" />
                  <div>
                    <p className="font-bold text-white font-['Space_Grotesk']">{testimonial.name}</p>
                    <p className="text-sm text-[#9CA3AF]">{testimonial.role}</p>
                  </div>
                </div>

                <div className="mt-4 inline-block px-3 py-1 bg-[#00E5FF]/10 border border-[#00E5FF]/30 text-[#00E5FF] text-sm font-medium rounded-full">
                  {testimonial.type}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
